module.exports = __webpack_public_path__ + "img/girocard.387c5ba0.png";